import React from 'react';
import { withRouter } from 'next/router';

import Header from 'react-scale/components/elements/header';
import HubspotForm from 'react-scale/components/website/big/main/HubspotForm';
import Footer from 'react-scale/components/elements/footer';

import { themeLight } from 'react-scale/components/elements/header/header-themes';

const Download = ({ router }) => (
  <div>
    <Header
      title="Waterloo Open Datasets Download - Scale"
      canonical="https://scale.com/open-av-datasets/waterloo/download"
      favicon="open-datasets/waterloo"
      description="Open-source dataset for autonomous driving in wintry weather.Open-source dataset for autonomous driving in wintry weather."
      ogImg="https://scale.com/static/img/website/open-datasets/waterloo/social/fb.png"
      twImg="https://scale.com/static/img/website/open-datasets/waterloo/social/tw.png"
      theme={{
        ...themeLight
      }}
    />
    <HubspotForm
      title="Open-source Dataset"
      subtitle="Explore the high-quality open dataset for autonomous driving in wintry weather."
      portalId="4823527"
      formId="90263334-f29a-4610-ba0b-7accf0734b88"
      image={{
        src: '/static/img/website/open-datasets/waterloo/dataset-cover.svg',
        alt: 'the Waterloo dataset cover art',
        type: 'dataset',
        background: '#000'
      }}
      pathName="/open-av-datasets/waterloo"
      router={router}
    />
    <Footer border />
  </div>
);

export default withRouter(Download);
